import sprite from "@/icons/sprite.symbol.svg";
import classNames from "classnames";

export interface IconProps {
  className?: string;
  name: string;
  width?: number;
  height?: number;
}

export const Icon = ({ className, name, ...rest }: IconProps) => (
  <svg className={classNames("icon", className && className)} {...rest}>
    <use xlinkHref={sprite + "#" + name} />
  </svg>
);
